import { useFeatureVariationDecision } from 'plugins/optimizely/hooks/use-feature-variation';
import { IMMEDIATE_FEATURES } from 'utils/experiment';
import { useBreakpointValue } from '@spothero/ui';
import { useReduxSearchState } from 'pages/search/hooks/use-redux-search-state';
export const _mapToLimits = (input) => {
    const mapLimits = (cl) => {
        return {
            initialResultLimit: cl.ir,
            subsequentResultLimit: cl.sr,
            maxDistance: cl.md, // in meters
        };
    };
    if (!input) {
        return undefined;
    }
    return {
        cityLimits: mapLimits(input.c),
        addressLimits: mapLimits(input.a),
        destinationLimits: mapLimits(input.d),
        eventLimits: mapLimits(input.e),
        defaultLimits: mapLimits(input.o),
    };
};
export const _findLimitBySearchType = (searchTye, limits) => {
    if (!searchTye || !limits) {
        return undefined;
    }
    switch (searchTye) {
        case 'city':
            return limits.cityLimits;
        case 'address':
            return limits.addressLimits;
        case 'destination':
            return limits.destinationLimits;
        case 'event':
            return limits.eventLimits;
        default:
            return limits.defaultLimits;
    }
};
export const useSearchLimitValue = () => {
    const { searchType } = useReduxSearchState();
    const isMobile = useBreakpointValue({ base: true, tablet: false }, { ssr: false });
    const decision = useFeatureVariationDecision(IMMEDIATE_FEATURES.ACQUISITION_SEARCH_MAP_LIMIT_VALUES);
    const optimizelyVariable = decision.variables
        .limits;
    // The feature flag when available has both mobile and desktop limits
    if (!decision.enabled || !optimizelyVariable?.m || !optimizelyVariable.d) {
        return undefined;
    }
    const searchLimits = isMobile
        ? _mapToLimits(optimizelyVariable.m)
        : _mapToLimits(optimizelyVariable.d);
    return _findLimitBySearchType(searchType, searchLimits);
};
